// store.js
import { create } from "zustand";
import { createAsyncFetcher } from "./utilities/Fetch/createAsyncFetcher";
import { fetchHomes } from "./services/apiHomes";
import { fetchProductos } from "./services/apiProductos";
import { fetchNosotros } from "./services/apiNosotros";
import { fetchFaq } from "./services/apiFaq";
import { fetchWhats } from "./services/apiWhats";
import { fetchHeader } from "./services/apiHeader";
import { fetchFooter } from "./services/apiFooter";
import { fetchChatbot as apiFetchChatbot } from "./services/apiFetchChatbot";
import { fetchPromociones } from "./services/apiPromociones";
import { fetchBlog } from "./services/apiBlog";

const useStore = create((set, get) => ({
  loading: false,       // loading global (homes, etc.)
  chatLoading: false,   // loading SOLO del chat ✅
  error: null,

  homes: [],
  productos: [],
  nosotros: [],
  faq: [],
  whats: [],
  header: [],
  footer: [],
  chatBot: [], // [{ role: "user"|"bot", text, nlp? }]
  promociones: [],
  blog: [],

  resetError: () => set({ error: null }),

  fetchHomes: createAsyncFetcher(fetchHomes, "homes", set),
  fetchBlog: createAsyncFetcher(fetchBlog, "blog", set),
  fetchProductos: createAsyncFetcher(fetchProductos, "productos", set),
  fetchPromociones: createAsyncFetcher(fetchPromociones, "promociones", set),
  fetchNosotros: createAsyncFetcher(fetchNosotros, "nosotros", set),
  fetchFaq: createAsyncFetcher(fetchFaq, "faq", set),
  fetchWhats: createAsyncFetcher(fetchWhats, "whats", set),
  fetchHeader: createAsyncFetcher(fetchHeader, "header", set),
  fetchFooter: createAsyncFetcher(fetchFooter, "footer", set),

  // Enviar mensaje del usuario y luego pedir respuesta al backend
  sendChatMessage: async (text) => {
    if (!text?.trim()) return;
    set((state) => ({ chatBot: [...state.chatBot, { role: "user", text }] }));
    await get().fetchChatbot(text);
  },

  // fetchChatbot que APPENDEA y usa chatLoading en lugar de loading
  fetchChatbot: createAsyncFetcher(
    apiFetchChatbot,
    "chatBot",
    set,
    {
      loadingKey: "chatLoading",
      updater: (state, data /* { reply, options, nlp } */) => ({
        chatBot: [...state.chatBot, { role: "bot", text: data.reply, options: data.options || [], nlp: data.nlp }]
      })
    }
  ),
}));

export default useStore;